import { httpUtil } from "./httpUtil";
import { createCommonResult, createResult, ErrorCodes } from "./resultUtil";

export const contacts = {
    authenticateEmail,
    authenticate,
    getContact,
    getContactDemographics,
    getPhones,
    updateContact,
    updatePhone,
    addPhone,
    deletePhone,
    getListPaymentMethods,
    changePassword,
    getAddresses,
    updateAddress,
    contactRegister,
    addAddress,
    getListContactServices,
    getProductDetail,
    forgotPassword,
    updateCustomFieldsContact,
    updateContactConsents,
}


async function authenticateEmail({ username, password, application_id }, startSession = true) {
    return authenticate(
        {
            username,
            password,
            application_id,
            provider: "EMAIL",
        },
        startSession
    );
}

async function authenticate(contact, startSession = true) {
    try {
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/authenticate",
            body: contact,
            logOutIfSessionInvalid: false,
        });
        if (startSession == true && response.code == "OK" && response.data && response.data.access_token) {
            httpUtil.startSession(response.data);
        }
        //check return code here instead of put as there would be different intepretation for different API
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            if (
                response.error &&
                response.error.message == "COM.CRM.EXCEPTIONS.INVALIDLOGINEXCEPTION"
            ) {
                return createResult(ErrorCodes.INVALID_LOGIN, response.error);
            } else if (response.error &&
                response.error.error == "COM.CRM.EXCEPTIONS.EMAILNOTVERIFIEDEXCEPTION") {
                return createResult(ErrorCodes.EMAIL_NOT_VERIFIED, response.error);
            } else if (response.code == '429') {
                return createResult(ErrorCodes.TOO_MANY_REQUESTS, response.error);
            }
            else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getContact() {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.get({
            resourcePath: "/v1/contacts/" + id,
            queryParams: { include_financials: true },
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getContact: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getContactDemographics() {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.get({
            resourcePath: "/v1/contacts/" + id + "/demographics",
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getContactDemographics: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getPhones() {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.get({
            resourcePath: "/v1/contacts/" + id + "/phones",
            withAccessToken: true,
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getPhones: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function updateContact(
    { first_name, last_name, email_address },
    { gender, date_of_birth, name_day, passport, id_details }
) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.put({
            resourcePath: "/v1/contacts/" + id,
            body: {
                first_name,
                last_name,
                email_address,
                demographics: {
                    gender,
                    date_of_birth,
                    name_day,
                    passport,
                    id_details
                },
            },
        });
        //check return code here instead of put as there would be different intepretation forGotr different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception updateContact: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function updatePhone({ phone_id, number, country_code }) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.put({
            resourcePath: "/v1/contacts/" + id + "/phones/" + phone_id,
            body: {
                number,
                country_code,
            },
            withAccessToken: true,
        });
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            if (
                response.error && (response.error.error ==
                    "COM.CRM.EXCEPTIONS.CONTACTS.CIMALREADYEXISTSFORANOTHERCONTACTEXCEPTION" || response.error.error ==
                    "COM.CRM.EXCEPTIONS.CIMALREADYEXISTSFORANOTHERCONTACTEXCEPTION")


            ) {
                return createResult(
                    ErrorCodes.PHONE_NUMBER_ALREADY_EXIST,
                    response.error
                );
            } else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception update phone: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function addPhone({
    is_primary,
    number,
    country_code,
    phone_type = "MOBILE",
}) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/" + id + "/phones",
            body: {
                is_primary,
                number,
                country_code,
                phone_type,
            },
            withAccessToken: true,
        });
        // return createCommonResult(response);
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            if (
                response.error &&
                (response.error.error ==
                    "COM.CRM.EXCEPTIONS.CONTACTS.CIMALREADYEXISTSFORANOTHERCONTACTEXCEPTION" || response.error.error ==
                    "COM.CRM.EXCEPTIONS.CIMALREADYEXISTSFORANOTHERCONTACTEXCEPTION")
            ) {
                return createResult(
                    ErrorCodes.PHONE_NUMBER_ALREADY_EXIST,
                    response.error
                );
            } else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception update phone: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function deletePhone(phone_id) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.sendDelete({
            resourcePath: "/v1/contacts/" + id + "/phones/" + phone_id,
            withAccessToken: true,
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception update phone: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getListPaymentMethods({
    page = 1,
    size = 10,
    sort, //='UPDATED_DATE',
    order, //='DESC',
} = {}) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.get({
            resourcePath: "/v1/contacts/" + id + "/payment_methods",
            queryParams: {
                page,
                size,
                sort,
                order,
            },
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getListPaymentMethods: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function changePassword(new_password) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/" + id + "/change_password",
            body: {
                password: new_password,
            },
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception update phone: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getAddresses() {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.get({
            resourcePath: "/v1/contacts/" + id + "/addresses",
            withAccessToken: true,
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getAddresses: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function updateAddress(
    {
        care_of,
        address_line_1,
        address_line_2,
        address_name,
        state_province_county,
        town_city,
        postal_code,
        country_code,
        lat,
        lon,
        is_primary = true,
    },
    addressId
) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.put({
            resourcePath: "/v1/contacts/" + id + "/addresses/" + addressId,
            body: {
                care_of,
                address_name,
                address_line_1,
                address_line_2,
                state_province_county,
                town_city,
                postal_code,
                country_code,
                is_primary,
                lat,
                lon
            },
            withAccessToken: true,
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception updateAddress: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function contactRegister({
    first_name,
    last_name,
    identity,
    service_acceptance = true,
    email_opt_out = false,
    sms_opt_out = false,
}) {
    try {
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/register",
            body: {
                first_name,
                last_name,
                identity,
                service_acceptance,
                email_opt_out,
                sms_opt_out
            },
            logOutIfSessionInvalid: false,
        });
        console.log("response===", response);
        if (response.code === "OK" && response.data && response.data.access_token) {
            httpUtil.startSession(response.data);
            return createResult(ErrorCodes.OK, response.data);
        }
        else {
            if (response.error && (response.error.error == "COM.CRM.EXCEPTIONS.MORETHANONEENTITYEXISTSEXCEPTION" || response.error.error == "CRM.EXCEPTIONS.MORETHANONEENTITYEXISTSEXCEPTION")) {
                return createResult(
                    ErrorCodes.REGISTRATION_FAIL_CONTACT_EXISTS,
                    response.error
                );
            } else if ( response.error && response.error.error == "COM.CRM.EXCEPTIONS.INVALIDPASSWORDEXCEPTION" ) {
                return createResult(
                    ErrorCodes.INVALID_PASSWORD_EXCEPTION,
                    response.error
                );
            } else if (
                response.error &&
                response.error.error ==
                "COM.CRM.EXCEPTIONS.INVALIDCONTACTPASSWORDEXCEPTION"
            ) {
                return createResult(
                    ErrorCodes.PASSWORD_LENGTH_EXCEPTION,
                    response.error
                );
            } else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception contactRegister: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function addAddress({
    address_type,
    address_name,
    address_line_1,
    address_line_2,
    state_province_county,
    town_city,
    postal_code,
}, contactId) {
    try {
        let response = await httpUtil.put({
            resourcePath: "/v1/contacts/" + contactId + "/addresses",
            body: {
                address_type,
                address_name,
                address_line_1,
                address_line_2,
                state_province_county,
                town_city,
                postal_code,
            },
            logOutIfSessionInvalid: false,
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception contact addAddress: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getListContactServices({
    sort,
    order,
    page = 1,
    size = 20,
    classification,
} = {}) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.get({
            resourcePath: "/v1/contacts/" + id + "/services",
            queryParams: {
                sort,
                order,
                page,
                size,
                classification,
                include_subscription: true
            },
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getListContactServices: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}
async function getProductDetail(productID) {
	try {
		let response = await httpUtil.get({
			resourcePath: '/v1/products/' + productID,
			queryParams: {},
			withAccessToken: true
		});
		//check return code here instead of put as there would be different intepretation for different API
		return createCommonResult(response);
	} catch (e) {
		console.log('Exception get product categories: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}
async function forgotPassword(email) {
    try {
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/forgot_password",
            body: {
                username: email,
            },
            logOutIfSessionInvalid: false
        });
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            if (response.error && response.error.error == "COM.CRM.EXCEPTIONS.INVALIDVALUEEXCEPTION") {
                return createResult(ErrorCodes.FORGOT_EMAIL_NOT_FOUND_EXCEPTION, response.error);
            } else if (response.code == '429') {
                return createResult(ErrorCodes.TOO_MANY_REQUESTS, response.error);
            } else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception update phone: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}
async function updateCustomFieldsContact(
    custom_fields,
) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.put({
            resourcePath: "/v1/contacts/" + id,
            body: {
                custom_fields,
            },
        });
        //check return code here instead of put as there would be different intepretation forGotr different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception updateCustomFieldsContact: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function updateContactConsents({ email_opt_out, sms_opt_out }) {
    try {
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.put({
            resourcePath: "/v1/contacts/" + id,
            body: {
                email_opt_out,
                sms_opt_out,
            },
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception updateContactConsents: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}
